import { Link } from 'react-router-dom';

// Services
import { type BlocListeCardsType } from '@/services/blocksSchema';

// Components
import Heading from '@/components/atoms/Heading/Heading';

// Style
import styles from './BlocListeCards.module.css';

interface BlocListeCardsProps {
  title: BlocListeCardsType['title'];
  subTitle: BlocListeCardsType['subTitle'];
  cards: BlocListeCardsType['cards'];
}

function BlocListeCards({
  title,
  subTitle,
  cards,
}: BlocListeCardsProps) {
  
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.heading}>
          <Heading
            title={title}
            color='dark'
            size='h2'
            Tag='h2'
            align='center'
            weight='700'
          />
          <Heading
            title={subTitle}
            color='dark'
            size='h3'
            Tag='h3'
            align='center'
            weight='500'
          />
        </div>
        <div className={styles.cards}>
          {
            cards.map((card) => (
              <div key={card.id} className={styles.card}>
                <img
                  src={card.image.url}
                  alt={card.image.alternativeText || ''}
                  className={styles['card-image']}  
                />
                <div className={styles['card-content']}>
                  <Heading
                    title={card.title}
                    color='dark'
                    size='h5'
                    Tag='h5'
                    align='center'
                    weight='700'
                  />
                  <p className={styles['card-description']} >
                    {card.description}
                  </p>
                  <Link to={card.cta.url} className={styles['card-link']}>
                    {card.cta.title}
                  </Link>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
}

export default BlocListeCards;
